export const CUSTOM_FIELD_LABEL_MAX_LENGTH = 100;
export const CUSTOM_FIELD_PLACEHOLDER_MAX_LENGTH = 50;
export const CUSTOM_FIELD_SELECT_MAX_OPTIONS = 10;
export const CUSTOM_FIELD_SELECT_OPTION_TEXT_MAX_LENGTH = 50;
export const CUSTOM_FIELD_ENABLED_PER_ORG_MAX = 25;
export const CUSTOM_FIELD_TOTAL_PER_ORG_MAX = 50;
